<template>
  <DefaultLayout
    :pageProps="{
      title: 'Choose a new password',
    }"
  >
    <template #content>
      <SetNewPassword />
    </template>
  </DefaultLayout>
</template>

<script>
import SetNewPassword from "@/components/forms/SetNewPassword";
import DefaultLayout from "@/layout/DefaultLayout.vue";
export default {
  name: "set-new",
  components: { DefaultLayout, SetNewPassword },
};
</script>
